import { createContext } from 'preact/compat';
export const optionsDefaults = {
    formAction: '/search.html',
    backButton: {
        link: undefined,
        text: 'Go back',
    },
    resultsTitle: 'Search results for:',
    initialSearchItems: [],
    initialMore: true,
    initialSearch: 'Initial Search',
    initialTotal: 0,
    perPage: 10,
};
export const OptionsCTX = createContext(optionsDefaults);
